export default __webpack_public_path__ + "static/media/bag-icon.0536a050.png";